import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, bonusValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-gray-200 bg-pearl py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-18" data-mp="1ydi6yabp1vla">
      <div className="mx-auto max-w-4xl px-4" data-id="element-19" data-mp="1anxijbwru64m">
        <SectionHeading id="bonus-title" data-id="element-20" data-mp="1aop9g9ffbfok">The {totalBonuses} <span className="text-aqua" data-id="element-21" data-mp="15q5itvpvxfpv">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm" data-id="element-22" data-mp="1jgr6ryu74fum">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-gray-200 p-5 last:border-b-0 sm:p-6" data-id="element-23" data-mp="1eo7q2t07p4ll" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-aqua-soft text-aqua" data-id="element-24" data-mp="2jhcvqxr1pe0v">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-25" data-mp="2ofxyb3trs9sh" />
                </span>
                <div data-id="element-26" data-mp="1qu0l9ly5swnx">
                  <p className="text-xs font-semibold uppercase tracking-wider text-gold-dark" data-id="element-27" data-mp="1qus37tyu2vvq">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-bold leading-snug text-navy" data-id="element-28" data-mp="1vuegg3enwc4j">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-gray-600" data-id="element-29" data-mp="20q3m8oh9yp9a">{bonus.description}</p>
                  <p className="mt-2 text-sm" data-id="element-30" data-mp="25oesyqc9wjna">
                    <span className="text-gray-400 line-through decoration-gray-400" data-id="element-31" data-mp="3c7d1szxa8x5b">{bonusValue}</span>
                    <span className="ml-2 font-bold text-aqua" data-id="element-32" data-mp="3h4vcauqy7kff">FREE</span>
                  </p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-xl border-2 border-gold bg-white px-6 py-6 text-center shadow-sm sm:flex-row sm:text-left" data-id="element-33" data-mp="1h586qxvlxhah">
          <div data-id="element-34" data-mp="1q3aerxdrda79">
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-500" data-id="element-35" data-mp="1q1r02b7r377l">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-gray-400 line-through decoration-gray-400 decoration-2" data-id="element-36" data-mp="yce5f6qwpnoq">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-37" data-mp="174zaxl5j1xvm">
            <p className="text-xs font-semibold uppercase tracking-wider text-gray-500" data-id="element-38" data-mp="176sh6zc8ag33">Your price today</p>
            <p className="mt-1 inline-flex items-center gap-2 text-4xl font-bold tracking-tight text-aqua" data-id="element-39" data-mp="12cxxvx0jc34j">
              <GiftIcon className="h-7 w-7" aria-hidden="true" data-id="element-40" data-mp="en3m7irycklv" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}